function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _CustomElement() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}

;
Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);

/* icon/UI 24px/Clipboard (list, clipboard, document).svg: width 24px x height 24px */
var DlsIconClipboard =
/*#__PURE__*/
function (_CustomElement2) {
  _inherits(DlsIconClipboard, _CustomElement2);

  function DlsIconClipboard() {
    _classCallCheck(this, DlsIconClipboard);

    return _possibleConstructorReturn(this, _getPrototypeOf(DlsIconClipboard).apply(this, arguments));
  }

  _createClass(DlsIconClipboard, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" display=\"block\" pointer-events=\"none\" viewBox=\"0 0 24 24\"><path fill=\"currentColor\" d=\"M16.331 14.777H8.226a.69.69 0 100 1.384h8.08a.69.69 0 00.692-.692c.025-.37-.296-.691-.667-.691zm0 3.435H8.226a.69.69 0 100 1.384h8.08a.69.69 0 00.692-.692c.025-.37-.296-.692-.667-.692zM10.4 11.021h1.162v1.162a.69.69 0 101.384 0V11.02h1.161a.69.69 0 00.692-.692.707.707 0 00-.692-.692h-1.161v-1.16a.69.69 0 10-1.384 0v1.161H10.4a.69.69 0 00-.692.692c0 .371.322.692.692.692z\"/><path fill=\"currentColor\" d=\"M19.865 3.138h-3.237v-.914a.69.69 0 00-.692-.692h-1.533C14.083.642 13.268 0 12.278 0c-.988 0-1.828.642-2.125 1.532H8.621a.69.69 0 00-.692.692v.914H4.692A.69.69 0 004 3.83v18.93a.69.69 0 00.692.691H19.84a.69.69 0 00.692-.692V3.855a.677.677 0 00-.667-.717zM9.338 2.916h1.408a.69.69 0 00.692-.692c0-.445.37-.815.816-.815.444 0 .815.37.815.815a.69.69 0 00.692.692h1.409v1.656H9.338V2.916zm9.81 19.151H5.408V4.547H7.93v.717a.69.69 0 00.692.691h7.265a.69.69 0 00.692-.691v-.717h2.545v17.52h.025z\"/></svg>";
    }
  }], [{
    key: "define",
    value: function define() {
      var tagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'dls-icon-clipboard';

      try {
        window.customElements.define(tagName, this);
      } catch (e) {
        /* console.error(e); */
      }
    }
  }]);

  return DlsIconClipboard;
}(_CustomElement);

export { DlsIconClipboard as default };
DlsIconClipboard.define();